import { Header } from './components/header/header.mjs';
import { PasswordStrength } from './components/password-strength/password-strength.mjs';

const createAll = (Component) => {
    $(`[data-module="${Component.moduleName}"]`).each((_index, componentElement) => {
        new Component($(componentElement)).init();
    });
};
const initAll = () => {
    const components = [
        Header,
        PasswordStrength,
    ];
    components.forEach((Component) => {
        createAll(Component);
    });
};

export { createAll, initAll };
//# sourceMappingURL=init.mjs.map
